module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"technical_alert_text":"Внимание! Ведутся технические работы, возможны неполадки."},"en":{"technical_alert_text":"Attention! Technical work is underway, possible malfunctions."}}')
  delete Component.options._Ctor
}
